export function throttle(func, ms) {

	let isThrottled = false,
		savedArgs,
		savedThis;

	function wrapper() {

		if (isThrottled) { // (2)
			savedArgs = arguments;
			savedThis = this;
			return;
		}

		func.apply(this, arguments); // (1)

		isThrottled = true;

		setTimeout(function () {
			isThrottled = false; // (3)
			if (savedArgs) {
				wrapper.apply(savedThis, savedArgs);
				savedArgs = savedThis = null;
			}
		}, ms);
	}

	return wrapper;
}


export function arrayToData(array) {
    return array.map(el => {
        const [name, body, organization, from] = el
        return {
            name,
            body,
            organization,
            from
        }
    });;
}

export function arrayToData25(array) {
    return array.map(el => {
        const [name,from, title, section] = el
        return {
            name,
            title,
            section,
            from
        }
    });;
}